module.exports = __webpack_public_path__ + "fonts/DejaVuSansMono.323d0db0.ttf";